export const splashInit = () => {

    let splashes = document.querySelectorAll(".splash")
    let body = document.body

    if (sessionStorage.getItem('splashed') == null && body.classList.contains("gen2-recruit") && body.classList.contains("recruit")) {

        noscroll()
        splashes.forEach((splash) => {
            splash.classList.add("splash-is-on")
        })
        sessionStorage.setItem('splashed', true);

    } else {
        body.classList.add("splashed")
    }
}

function noscroll() {
    document.addEventListener('touchmove', disableScroll, {
        passive: false
    });
    document.addEventListener('mousewheel', disableScroll, {
        passive: false
    });
    setTimeout(() => {
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
        document.body.classList.add("splashed")
    }, 3600);
}

function disableScroll(event) {
    event.preventDefault();
}